import React from 'react';
import Page from '../../layout/Page';
import AirPay from './AirPay';
import RoleProtected, { userRoles } from '../../RoleProtected';

const AirPayPage = () => (
    <RoleProtected roles={userRoles.accountConfiguration}>
        <Page title='AirPAY' icon='mobile'>
            <AirPay />
        </Page>
    </RoleProtected>
);

export default AirPayPage;
